<template>
    <div id="rightSideNav"
         class="details-sidenav"
         :class="{open: currentDamSelected}"
         :style="styleObject"
    >
        <RightPanelContainer></RightPanelContainer>
    </div>
</template>

<script>
    // vuex
    import {mapGetters} from "vuex";
    // components
    import RightPanelContainer from "./RightPanelContainer";

    /**
     * This components serves as a main wrapper for the
     * actual container and the bottom part - view details.
     */

    export default {
        name: "RightPanel",
        components: {
            RightPanelContainer
        },
        props: {

        },
        data() {
            return {
                styleObject: {
                    width: this.computedWidth
                }
            }
        },
        computed: {
            ...mapGetters(['currentDamSelected']),
            /**
             * If right panel is open, change width to 320.
             * @returns {number}
             */
            computedWidth() {
                return this.currentDamSelected ? 320: 0;
            }
        }
    }
</script>

<style lang="scss" scoped>
     @import "../../assets/scss/variables";
/****************************************************************************
  RiGHT PANEL
****************************************************************************/

    .details-sidenav {
        /* dimensions */
        height: calc(100vh - 148px);
        width: 0;
        /* position and placement */
        position: fixed;
        bottom: 0;
        right: 0;
        /* background and shadow */
        background-color: $whiteColor;
        box-shadow: -3px 0px 6px rgba(0, 4, 125, 0.102);
        /* visibility */
        z-index: 1;
        opacity: 1;
        overflow-x: hidden;
        /* transitions */
        -webkit-transition: all 0.5s ease;
        -moz-transition: all 0.5s ease;
        -o-transition: all 0.5s ease;
        transition: all 0.5s ease;
        /* prevent squash */
        white-space: nowrap;
        &.open {
            /* margins and puddings */
            width: 395px;
        }
    }

    /* Changing the padding is done as animation */
    #map-list-wrapper {
        transition: padding-right .6s;
    }

     @media (max-width: 768px) {
         .details-sidenav.open {
             width: 100%;
         }
     }
</style>